import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PaddingModel } from '../../../models/padding.model';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'agpr-block-padding',
    templateUrl: './block-padding.component.html',
    styleUrls: ['./block-padding.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: BlockPaddingComponent
        }
    ],
    standalone: false
})
export class BlockPaddingComponent implements ControlValueAccessor {

    @Input() id: string;
    @Input() padding: PaddingModel = new PaddingModel();
    @Input() verticalOnly = false;
    @Input() headerClass: string = '';
    @Input() headerLabelHeading: boolean = true;
    @Input() showLabel: boolean = true;
    @Output() paddingChanged = new EventEmitter<PaddingModel>();

    constructor() {}

    writeValue(value: any): void {
        this.padding = value;
    }

    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    registerOnChange(fn): void {
        this.onModelChange = fn;
    }

    registerOnTouched(fn: Function): void {
        this.onModelTouched = fn;
    }

    optionChange(event: boolean) {
        if (event) {
            if (this.verticalOnly){
                this.padding.bottomPadding = this.padding.topPadding = this.padding.paddingAll;
                this.padding.leftPadding =  this.padding.rightPadding = 0;
            } else {
                this.padding.bottomPadding = this.padding.leftPadding = this.padding.topPadding =
                this.padding.rightPadding = this.padding.paddingAll;
            }
        } else {
            this.padding.paddingAll = this.padding.topPadding;
        }
        this.padding.paddingOption = event;
        this.onValueChange();
    }

    onValueChange() {
        this.onModelChange(this.padding);
        this.paddingChanged.emit(this.padding);
    }
}
